module.exports = __webpack_public_path__ + "dogs.jpg?72a1411439583e303713dcd6a71117bb";